import { render, staticRenderFns } from "./TagManagement.vue?vue&type=template&id=7ec8f41e&"
import script from "./TagManagement.vue?vue&type=script&lang=js&"
export * from "./TagManagement.vue?vue&type=script&lang=js&"
import style0 from "./TagManagement.vue?vue&type=style&index=0&id=7ec8f41e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports